export default {
  chats: [],
  total_chats_length: 0,

  currentChat: undefined,
  overloadMessages: false
}
